import Vue from "vue";
import Vuex from "vuex";
import VueMeta from "vue-meta";

Vue.use(Vuex);

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true,
});

export default new Vuex.Store({
  state: {
    initialTitle: "Master of Pharmacy",
    systemPageTitle: "",
    systemCardList: [
      {
        shortName: "Non Grading System",
        fullName: "Non Grading System",
        pointers: [
          "Subject Notes",
          "Question Paper",
          "Course Syllabus",
          "Syllabus Scheme",
        ],
        buttonText: "Learn More",
        url: "NonGradingSystem",
      },
      {
        shortName: "Grading System",
        fullName: "Grading System",
        pointers: [
          "Subject Notes",
          "Question Paper",
          "Course Syllabus",
          "Syllabus Scheme",
        ],
        buttonText: "Learn More",
        url: "GradingSystem",
      },
    ],
    commonLinks: {
      courseSyllabus: "/view-syllabus",
      examTimeTable: "/view-time-table",
      syllabusScheme: "/view-scheme",
      examResult: "/view-result",
      newsUpdate: "/view-news",
      studyNotes: "notes",
      questionPaper: "qp",
    },
  },
  getters: {
    initialTitle: (state) =>
      state.systemPageTitle
        ? `${state.initialTitle} - ${state.systemPageTitle}`
        : state.initialTitle,
    systemCardList: (state) => state.systemCardList,
    commonLinks: (state) => state.commonLinks,
  },
  mutations: {
    updateSystemPageTitle(state, systemPageTitle) {
      state.systemPageTitle = systemPageTitle;
    },
  },
  actions: {
    updateSystemPageTitle(context, systemPageTitle) {
      context.commit("updateSystemPageTitle", systemPageTitle);
    },
  },
  modules: {},
});
